import {Component, OnDestroy, OnInit} from '@angular/core';
import {OverlayService} from "../../../overlay/overlay.service";

@Component({
  selector: 'brt-wizard-icon',
  templateUrl: './wizard-icon.component.html',
  styleUrls: ['./wizard-icon.component.scss']
})
export class WizardIconComponent {

  constructor(private overlay: OverlayService) {
  }
}
